import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import AdminAction from './AdminAction';

/**
 * Non-dismissible session timeout warning shown after idle period.
 */
export default function SessionTimeoutDialog({
  open,
  countdown,
  onContinue,
  onLogout,
  loading = false,
}) {
  const [displayCountdown, setDisplayCountdown] = useState(countdown);

  useEffect(() => {
    setDisplayCountdown(countdown);
  }, [countdown]);

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={() => {}}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: '12px' } }}
      aria-labelledby="session-timeout-title"
      BackdropProps={{
        sx: { backgroundColor: 'rgba(28, 25, 23, 0.55)' },
      }}
    >
      <DialogTitle
        id="session-timeout-title"
        sx={{ fontWeight: 700, pb: 1 }}
      >
        Session Expiring
      </DialogTitle>
      <DialogContent>
        <DialogContentText component="div" sx={{ color: '#57534e', mb: 2 }}>
          <p style={{ margin: '0 0 12px' }}>You&apos;ve been inactive for 30 minutes.</p>
          <p style={{ margin: '0 0 12px' }}>Your session is about to expire.</p>
          <p style={{ margin: 0 }}>Would you like to continue your session?</p>
        </DialogContentText>
        <DialogContentText
          sx={{
            color: '#b45309',
            fontWeight: 600,
            fontSize: '0.95rem',
            mt: 1,
          }}
        >
          Your session will expire in {Math.max(displayCountdown, 0)} seconds.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1, flexWrap: 'wrap' }}>
        <AdminAction
          variant="outline"
          onClick={onLogout}
          disabled={loading}
          sx={{ flex: '1 1 auto' }}
        >
          Logout
        </AdminAction>
        <AdminAction
          variant="primary"
          onClick={onContinue}
          loading={loading}
          sx={{ flex: '1 1 auto', minWidth: 140 }}
        >
          Continue Session
        </AdminAction>
      </DialogActions>
    </Dialog>
  );
}
